import type { QueryOptions } from "@tanstack/react-query"
import type { ExactPartial } from "@wagmi/core/internal"

import { Evaluate, getAddress } from "viem"
import {
  type GetPriceErrorType,
  type GetPriceParameters,
  type GetPriceReturnType,
  getPrice,
} from "../actions/getPrice"
import type { ExtendedConfig, ScopeKeyParameter } from "../types"
import { filterQueryOptions } from "../utils"

export type GetPriceOptions = Evaluate<
  ExactPartial<GetPriceParameters> & ScopeKeyParameter
>

export function getPriceQueryKey(options: GetPriceOptions = {}) {
  const { token, ...parameters } = options
  return [
    "price",
    filterQueryOptions({
      token: token && getAddress(token),
      ...parameters,
    }),
  ] as const
}

export function getPriceQueryFn(
  config: ExtendedConfig,
  options: GetPriceOptions = {},
) {
  const { ...parameters } = options
  return getPrice(config, parameters)
}

export function getPriceQueryOptions<config extends ExtendedConfig,>(
  config: config,
  options: GetPriceOptions,
) {
  return {
    gcTime: 0,
    queryFn: async ({ queryKey }) => {
      return getPriceQueryFn(config, queryKey[1])
    },
    queryKey: getPriceQueryKey(options),
  } satisfies QueryOptions<
    GetPriceQueryFnData,
    GetPriceErrorType,
    GetPriceData,
    GetPriceQueryKey
  >
}

export type GetPriceQueryFnData = GetPriceReturnType

export type GetPriceData = GetPriceQueryFnData

export type GetPriceQueryKey = ReturnType<typeof getPriceQueryKey>
